module.exports = __webpack_public_path__ + "static/img/3.1定位.c0e9653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3.1定位.png
// module id = auXv
// module chunks = 16